export function calculateMortgageValue(mortage, userPurchasePrice) {
  return (
    (parseFloat(mortage) * userPurchasePrice) / 100
  )
}
